import {startTransition} from 'react';
import {UseFormReturn} from 'react-hook-form';

import {isNotNil} from 'ramda';

import {PaymentDatesField, resolvePaymentDates} from '@dms/shared';

import {getApiDateString, parseDate} from 'shared/web';

import {FormValuesType} from '../types/FormValuesType';

export const getDepositPaymentFormHandlers = (formApi: UseFormReturn<FormValuesType>) => {
  const updateDependentDates = (changedField: PaymentDatesField) =>
    startTransition(() => {
      const values = formApi.getValues();
      const patch = resolvePaymentDates(changedField, {
        issueDate: parseDate(values.issuedDate),
        dueDays: values.dueSinceIssueDateInDays,
        dueDate: parseDate(values.dueDate),
        taxableSupplyDate: parseDate(values.dateOfTaxableSupply),
      });

      if (isNotNil(patch.dueDays)) {
        formApi.setValue('dueSinceIssueDateInDays', patch.dueDays);
      }
      if (isNotNil(patch.dueDate)) {
        formApi.setValue('dueDate', getApiDateString(patch.dueDate));
      }
    });

  const handleOnIssueDateChange = () => updateDependentDates('issueDate');
  const handleOnDueChange = () => updateDependentDates('dueDays');
  const handleOnDueDateChange = () => updateDependentDates('dueDate');

  return {handleOnIssueDateChange, handleOnDueChange, handleOnDueDateChange};
};
